import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';

import { difference, differenceBy } from 'lodash';

import { SelectableField } from '../../models';
import { FieldType } from '../../shared/enums';
import { Field } from '../logic-services/models';

@Injectable({
    providedIn: 'root'
})
export class DragAndDropFieldSelectionUtilityService {
    currentAvailableFieldState: Field[] = [];

    constructor() { }

    removeGridFieldsFromAvailableFields(selectedFields: Field[], availableFields: Field[]): Field[] {
        selectedFields.forEach((field: Field) => {
            if (field.dataId) {
                const dataId = field.dataId;
                availableFields = availableFields.filter((availableField: Field) =>
                    !availableField.dataId || availableField.dataId === dataId
                );
            }
        });

        return availableFields;
    }

    returnGridFieldsToAvailableFields(selectedFields: Field[], allFields: Field[]): Field[] {
        if (selectedFields.length === 0) {
            return allFields;
        }

        const differenceFields: Field[] = difference(allFields, selectedFields);

        let selectedFieldsDataId: string;
        selectedFields.forEach((field: Field) => {
            if (field.dataId) {
                selectedFieldsDataId = field.dataId;
            }
        });

        if (selectedFieldsDataId === undefined) {
            return differenceFields;
        }

        const availableFields = new Array<Field>();
        differenceFields.forEach((field: Field) => {
            if (field.dataId === selectedFieldsDataId || field.dataId === undefined) {
                availableFields.push(field);
            }
        });

        return availableFields;
    }

    removeDuplicateFields(selectedFields: Field[], availableFields: Field[]): Field[] {
        const fields: Field[] = differenceBy(availableFields, selectedFields, 'id');
        return fields;
    }

    removeGridFieldsFromAvailableSelectableFields(selectedFields: SelectableField[], availableFields: SelectableField[]): SelectableField[] {
        let filteredAvailableFields: SelectableField[] = differenceBy(availableFields, selectedFields, 'identifier.fieldId');
        filteredAvailableFields = filteredAvailableFields.filter((field: SelectableField) => {
            return !field.identifier.gridColumnId && field.fieldTypeId !== FieldType.Grid;
        });

        return filteredAvailableFields;
    }

    removeDuplicateSelectableFields(selectedFields: SelectableField[], availableFields: SelectableField[]): SelectableField[] {
        const fields: SelectableField[] = differenceBy(availableFields, selectedFields, 'identifier.fieldId');
        return fields;
    }

    removeGridFieldsFromAllSelectableFields(allFields: SelectableField[]): SelectableField[] {
        let filteredAllFields: SelectableField[] = [];
        filteredAllFields = allFields.filter((field: SelectableField) => {
            return !field.identifier.gridColumnId && field.fieldTypeId !== FieldType.Grid;
        });

        return filteredAllFields;
    }

    handleDragDropEvent<T>(event: CdkDragDrop<T[]>): void {
        if (event.previousContainer === event.container) {
            moveItemInArray(
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }
        else {
            transferArrayItem(
                event.previousContainer.data,
                event.container.data,
                event.previousIndex,
                event.currentIndex
            );
        }
    }

    fieldFilterChange(filterString: string): Field[] {
        const searchText = filterString.toLowerCase();
        return this.currentAvailableFieldState.filter((field) => {
            return field.Name.toLowerCase().includes(searchText)
                || (field.breadcrumb ?? '').toLowerCase().includes(searchText);
        });
    }
}
